import React, {Suspense} from "react";
import { Redirect, Route, Switch } from "react-router";
//import { Home } from "../../Home/Home";
//import { Hosting } from "../../Hosting/Hosting";
//import { MyProfil } from "../../Profil/MyProfil";
//import { Map } from "../../Map/Map";
//import { ListProperty } from "../../Properties/ListProperty";
//import { DetailAnnounce } from "../../Announces/DetailAnnounce";
//import { EditProperty } from "../../Properties/EditProperty";
//import { Search } from "../../Search/Search";
//import { ConfirmReservation } from "../../Reservation/ConfirmReservation";
//import { ConfirmReservationGuest } from "../../Reservation/ConfirmReservationGuest";
import { Accounts } from "../../Accounts/Accounts";
//import { Blog } from "../../Blog/Blog";
//import { LisHotel } from "../../Admin/Hotel/ListHotel";
//import { CreationHotel } from "../../Admin/Hotel/EditHotel";
//import { DetailBlog } from "../../Blog/DetailBlog";
//import { PaymentSuccess } from "../Payments/PaymentSuccess";
import { Category } from "../../Category/Category";
//import { AddPropertyCondition } from "../../Properties/AnnonceAdd";
//import { HotelEdit } from "../../Admin/Hotel/HotelEdit";
//import { ContentFooter } from "../ContentFooter";
import { NotFound } from "../NotFound";
//import { AddAnnounceHotel } from "../../Properties/AddAnnounceHotel";
//import { PaymentSuccessOrange } from "../Payments/PaymentSuccessOrange";
import { SuccessConfirmation } from "../../SuccessConfirmation/SuccessConfirmation";
//import { DetailReservation } from "../../Reservation/DetailReservation";
//import { ReceiptReservation } from "../../Reservation/components/ReceiptReservation/ReceiptReservation";
import { SuccessPayment } from "../Payments/SuccessPayment";
import { SuccessPaymentAnnounceAd } from "../Payments/SuccessPaymentAnnounceAd";
//import { Guide } from "../../Guide/Guide";
import Credit from "../../Credit/Credit";
import ScrollToTop from "../ScrollToTop";
//import {  ShortlinkStay } from "../../Search/SearchShortlink";
//import { Register } from "../Register/Register";
//import Sitemap from "../Sitemap";
import { PropagateLoader } from "react-spinners";
import { makeStyles, createStyles } from "@material-ui/core";
//import GuideDetail from "../../Guide/GuideDetail";
//import { AddAnnounceCars } from "../../Properties/AddAnnounceCars";
//import { AddAnnounceImmo } from "../../Properties/AddAnnounceImmo";
//import BlogHome from "../../Blog/BlogHome";
//import { AddAnnounceExperience } from "../../Properties/AddAnnounceExperience";

//import HomeVeh from "../../Home/HomeVeh";
import { IMapProps } from "../Mapview/MapView";

const DetailAnnounce = React.lazy(() => import("../../Announces/DetailAnnounce"));
const Search = React.lazy(() => import("../../Search/Search"));
const Blog = React.lazy(() => import("../../Blog/Blog"));
//const DetailBlog = React.lazy(() => import("../../Blog/DetailBlog"));
const DetailBlogGuide = React.lazy(() => import("../../Blog/DetailBlogGuide"));
const Home = React.lazy(() => import("../../Home/Home"));
const HomeVeh = React.lazy(() => import("../../Home/HomeVeh"));
const HomeTour = React.lazy(() => import("../../Home/HomeTour"));
const HomeHotel = React.lazy(() => import("../../Home/HomeHotel"));
const HomeEstate = React.lazy(() => import("../../Home/HomeEstate"));
const HomeEvent = React.lazy(() => import("../../Home/HomeEvent"));
const Guide = React.lazy(() => import("../../Guide/Guide"));
const Map = React.lazy(() => 
  import("../../Map/Map").then(module => ({
    default: module.default as React.ComponentType<IMapProps>
  }))
);


const BlogHome = React.lazy(() => import("../../Blog/BlogHome"));
const GuideDetail = React.lazy(() => import("../../Guide/GuideDetail"));
const Sitemap = React.lazy(() => import("../Sitemap"));
const MyProfil = React.lazy(() => import("../../Profil/MyProfil").then(module => ({ default: module.MyProfil })));
const ListProperty = React.lazy(() => import("../../Properties/ListProperty").then(module => ({ default: module.ListProperty })));
const ConfirmReservation = React.lazy(() => import("../../Reservation/ConfirmReservation").then(module => ({ default: module.ConfirmReservation })));
const ConfirmReservationGuest = React.lazy(() => import("../../Reservation/ConfirmReservationGuest").then(module => ({ default: module.ConfirmReservationGuest })));
const LisHotel = React.lazy(() => import("../../Admin/Hotel/ListHotel").then(module => ({ default: module.LisHotel })));
const CreationHotel = React.lazy(() => import("../../Admin/Hotel/EditHotel").then(module => ({ default: module.CreationHotel })));
const PaymentSuccess = React.lazy(() => import("../Payments/PaymentSuccess").then(module => ({ default: module.PaymentSuccess })));
const HotelEdit = React.lazy(() => import("../../Admin/Hotel/HotelEdit").then(module => ({ default: module.HotelEdit })));
const ContentFooter = React.lazy(() => import("../ContentFooter").then(module => ({ default: module.ContentFooter })));
const AddAnnounceHotel = React.lazy(() => import("../../Properties/AddAnnounceHotel").then(module => ({ default: module.AddAnnounceHotel })));
const PaymentSuccessOrange = React.lazy(() => import("../Payments/PaymentSuccessOrange").then(module => ({ default: module.PaymentSuccessOrange })));
const DetailReservation = React.lazy(() => import("../../Reservation/DetailReservation").then(module => ({ default: module.DetailReservation })));
const ReceiptReservation = React.lazy(() => import("../../Reservation/components/ReceiptReservation/ReceiptReservation").then(module => ({ default: module.ReceiptReservation })));
const Register = React.lazy(() => import("../Register/Register").then(module => ({ default: module.Register })));
const Hosting = React.lazy(() => import("../../Hosting/Hosting").then(module => ({ default: module.Hosting })));
const EditProperty = React.lazy(() => import("../../Properties/EditProperty").then(module => ({ default: module.EditProperty })));
const ShortlinkStay = React.lazy(() => import("../../Search/SearchShortlink").then(module => ({ default: module.ShortlinkStay })));
const AddAnnounceCars = React.lazy(() => import("../../Properties/AddAnnounceCars").then(module => ({ default: module.AddAnnounceCars })));
const AddAnnounceImmo = React.lazy(() => import("../../Properties/AddAnnounceImmo").then(module => ({ default: module.AddAnnounceImmo })));
const AddPropertyCondition = React.lazy(() => import("../../Properties/AnnonceAdd").then(module => ({ default: module.AddPropertyCondition })));
const AddAnnounceExperience = React.lazy(() => import("../../Properties/AddAnnounceExperience").then(module => ({ default: module.AddAnnounceExperience })));
 
//const ConfirmReservation = React.lazy(() => import("../../Reservation/ConfirmReservation"));
//const VehicleSearch = React.lazy(() => import("../../Search/VehiculeSearch"));
//const DetailReservation = React.lazy(() => import("../../Reservation/DetailReservation"));

const useStyles = makeStyles((theme) =>
    createStyles({
loading: {
    width: "100%",
    minHeight: "40vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
},
})
);

export function Content() {
    const classes = useStyles();
    return (
        <ScrollToTop>
            <Suspense fallback={
                <div className={classes.loading}>
                    <PropagateLoader color="#36D7B7" size={15}/>
                </div>}>
            <Switch>
                <Route path="/" exact>
                    <Home/>
                </Route>
                <Route path="/logements-meubles" exact>
                    <Home/>
                </Route>
                <Route path="/logements" exact>
                    <Home/>
                </Route>
                <Route path="/voitures" exact>
                    <HomeVeh/>
                </Route>
                <Route path="/hotels" exact>
                    <HomeHotel />
                </Route>
                <Route path="/restaurants-activites" exact>
                    <HomeTour />
                </Route>
                <Route path="/restaurants" exact>
                    <HomeTour />
                </Route>
                <Route path="/spas" exact>
                    <HomeTour />
                </Route>
                <Route path="/activites" exact>
                    <HomeTour />
                </Route>
                <Route path="/evenements" exact>
                    <HomeEvent />
                </Route>
                <Route path="/immobilier" exact>
                    <HomeEstate />
                </Route>
                <Route path="/recherche/restaurants-activites" exact>
                    <HomeTour />
                </Route>
                <Route path="/recherche/logements-meubles" exact>
                    <Home/>
                </Route>
                <Route path="/recherche/voitures" exact>
                    <HomeVeh/>
                </Route>
                <Route path="/recherche/hotels" exact>
                    <HomeHotel />
                </Route>
                <Route path="/recherche/immobilier" exact>
                    <HomeEstate />
                </Route>
                <Route path="/search">
                    <Search />
                </Route>
                <Route exact path="/guide-touristique">
                    <Guide />
                </Route>
                <Route path="/guides/:id">
                    <GuideDetail />
                </Route> 
                <Route path="/blog" exact>
                    <BlogHome />
                </Route>
                <Route path="/blog/rubrique" exact>
                    <Redirect to="/blog" />
                </Route>                
                <Route path="/blog/rubrique/:category/:theme?" exact> 
                    <Blog />
                </Route>
                <Route path="/blog/partenaires" exact>
                    <Redirect to="/blog" />
                </Route>
                <Route path="/blog/partenaires/:partnerSlug" exact>
                    <Blog />
                </Route>
                <Route path="/blog/:slug" exact>
                    <DetailBlogGuide />
                </Route>
                <Route path="/guide/:slug" exact>
                    <DetailBlogGuide />
                </Route>
                <Route path="/blogsearch" exact>
                    <Blog />
                </Route>
                <Route path="/details-announce-:id"> {/* //path="/annonce/:searchType/:slug-:id"  */}
                    <DetailAnnounce />
                </Route>
                <Route path="/exp_:propertyType/:slug/:city/:state/:id">
                    <DetailAnnounce />
                </Route>

                <Route path="/category" exact>
                    <Category />
                </Route>

                <Route path="/hosting">
                    <Hosting />
                </Route>

                <Route path="/profil">
                    <MyProfil />
                </Route>

                <Route path="/account">
                    <Accounts />
                </Route>

                <Route path="/announce/add" exact>
                    <AddPropertyCondition />
                </Route>
                
                <Route path="/announce/add/:id" exact>
                    <AddPropertyCondition />
                </Route>

                <Route path="/announceHotel/add" exact>
                    <AddAnnounceHotel />
                </Route>
                
                <Route path="/announceHotel/add/:id" exact>
                    <AddAnnounceHotel />
                </Route>
                <Route path="/announceCar/add" exact>
                    <AddAnnounceCars />
                </Route>
                <Route path="/announceCar/add/:id" exact>
                    <AddAnnounceCars />
                </Route>
                <Route path="/announceImmo/add" exact>
                    <AddAnnounceImmo />
                </Route>
                <Route path="/announceImmo/add/:id" exact>
                    <AddAnnounceImmo />
                </Route>
                <Route path="/announceExp/add" exact>
                    <AddAnnounceExperience />
                </Route>
                <Route path="/announceExp/add/:id" exact>
                    <AddAnnounceExperience />
                </Route>
                <Route path="/announces/" exact>
                    <ListProperty />
                </Route>
                <Route path="/announce/edit/:id" exact>
                    <EditProperty />
                </Route>
                <Route path="/map">
                    <Map />
                </Route>
                
                {/* Country Level */}
                <Route path="/:countryCode(cm|ga|sn|ci)/logements-meubles" exact>
                <ShortlinkStay />
                </Route>

                {/* Consolidated City Routes */}
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/logements-meubles" exact>
                <ShortlinkStay />
                </Route>
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/logements-meubles/:roomType(chambres|appartements|villas)" exact>
                <ShortlinkStay />
                </Route>
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/logements-meubles/appartements:rooms(1|2|3)" exact>
                <ShortlinkStay />
                </Route>

                {/* Consolidated Feature Routes */}
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/logements-meubles/:base(chambres|appartements|appartements1|appartements2|appartements3|villas)-:features(piscine|borddemer|generateur|climatisation|wifi|parking|cuisine|navette|familiale|spa|lave-linge|seche-cheveux|minibar|route|jacuzzi|baignoire|douche|restaurant|fitness|fete)"  exact>
                <ShortlinkStay />
                </Route>

                {/* Consolidated Feature Routes */}
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/logements-meubles/:base(chambres|appartements|appartements1|appartements2|appartements3|villas)" exact>
                <ShortlinkStay />
                </Route>                
                

                {/* Quartier Base Route */}
                <Route 
                path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/logements-meubles" 
                exact
                >
                <ShortlinkStay />
                </Route>

                {/* Quartier with Room Types */}
                <Route 
                path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/logements-meubles/:roomType(chambres|appartements|villas)" 
                exact
                >
                <ShortlinkStay />
                </Route>

                {/* Quartier with Numbered Apartments */}
                <Route 
                path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/logements-meubles/appartements:rooms(1|2|3)" 
                exact
                >
                <ShortlinkStay />
                </Route>

                {/* Quartier with Features */}
                <Route 
                path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/logements-meubles/:base(chambres|appartements|villas)-:features(piscine|borddemer|generateur|climatisation|wifi|parking|cuisine|navette|familiale|spa|lave-linge|seche-cheveux|minibar|route|jacuzzi|baignoire|douche|restaurant|fitness|fete)" 
                exact
                >
                <ShortlinkStay />
                </Route>

                {/* Quartier with Numbered Apartments + Features */}
                <Route 
                path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/logements-meubles/appartements:rooms(1|2|3)-:features(piscine|borddemer|generateur|climatisation|wifi|parking|cuisine|navette|familiale|spa|lave-linge|seche-cheveux|minibar|route|jacuzzi|baignoire|douche|restaurant|fitness|fete)" 
                exact
                >
                <ShortlinkStay />
                </Route>


                {/* Hotel Routes */}
                <Route path="/:countryCode(cm|ga|sn|ci)/hotels" exact>
                <ShortlinkStay />
                </Route>
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/hotels/:roomType(chambres|suites)?" exact>
                <ShortlinkStay />
                </Route>

                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/hotels" exact>
                <ShortlinkStay />
                </Route>
                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/hotels/:roomType(chambres|suites)" exact>
                <ShortlinkStay />
                </Route>

                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/hotels/:roomType(chambres|suites)-:features(piscine|borddemer|generateur|climatisation|wifi|parking|cuisine|navette|familiale|spa|lave-linge|seche-cheveux|minibar|route|jacuzzi|baignoire|douche|restaurant|fitness|fete)"  exact>
                <ShortlinkStay />
                </Route>

                <Route  path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/hotels/chambres:rooms(1|2|3)" exact>
                <ShortlinkStay />
                </Route>

                <Route path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)-:quartiers/hotels/chambres:rooms(1|2|3)" exact>
                <ShortlinkStay />
                </Route>

                <Route  path="/:countryCode(cm|ga|sn|ci)/:city(kribi|douala|limbe|yaounde)/hotels/chambres:rooms(1|2|3)-:features(piscine|borddemer|generateur|climatisation|wifi|parking|restaurant|spa|fitness|jacuzzi)" exact >
                <ShortlinkStay />
                </Route>

                <Route path="/siteplan">
                    <Sitemap />
                </Route>
                <Route path="/hotel">
                    <LisHotel />
                </Route>
                <Route path="/edit/hotel">
                    <CreationHotel />
                </Route>
                <Route path="/modif/hotel/:id" exact>
                    <HotelEdit />
                </Route>
                <Route path="/booking/details-announce-:id">
                    <ConfirmReservation />
                </Route>
                <Route path="/guestbooking/details-announce-:id">
                    <ConfirmReservationGuest />
                </Route>
                <Route path="/booking-details/:id">
                    <DetailReservation />
                </Route>
                <Route path="/booking/payment-done-successfully-:id">
                    <PaymentSuccess />
                </Route>

                <Route path="/booking-receipt-:id">
                    <ReceiptReservation />
                </Route>
                <Route path="/cancellation-receipt-:id">
                    <ReceiptReservation />
                </Route>
                <Route exact path="/booking-:id/payment/orange-done-successfully">
                    <PaymentSuccessOrange />
                </Route>

                <Route path="/sponsor-ads/payment-done-successfully-:id">
                    <PaymentSuccess />
                </Route>

                <Route exact path="/footer/:content">
                    <ContentFooter />
                </Route>

                <Route exact path="/users/registrations/email/confirm/:id">
                    <SuccessConfirmation />
                </Route>

                <Route exact path="/reservation/payment_success">
                    <SuccessPayment />
                </Route>

                <Route exact path="/announce-ad/payment_success">
                    <SuccessPaymentAnnounceAd />
                </Route>
                <Route exact path="/credit">
                    <Credit />
                </Route>
                <Route path="/register">
                    <Register handleOpenLoginDialog={function (): void {
                        throw new Error("Function not implemented.");
                    } } handleClose={function (): void {
                        throw new Error("Function not implemented.");
                    } } />
                </Route>

                <Route path="*" exact={true}>
                    <NotFound />
                </Route>
            </Switch>
            </Suspense>
        </ScrollToTop>
    );
}
